// https://v3-migration.vuejs.org/breaking-changes/events-api.html
import mitt from './utils/mitt'

const emitter = mitt()

export default emitter
